import React from 'react'
import Toolbar from './toolbar'

const FlexBlacklist = props => {
  return <Toolbar name='FlexBlacklist' />
}

export default FlexBlacklist
